import { render, staticRenderFns } from "./BaseSubNav.vue?vue&type=template&id=65b4fe30&scoped=true&lang=pug"
import script from "./BaseSubNav.vue?vue&type=script&lang=js"
export * from "./BaseSubNav.vue?vue&type=script&lang=js"
import style0 from "./BaseSubNav.vue?vue&type=style&index=0&id=65b4fe30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b4fe30",
  null
  
)

export default component.exports